import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { getSalonRoute } from '@app/shared/utils';

@Component({
  selector: 'app-visit-review-about-salon',
  templateUrl: './about-salon.component.html',
  styleUrls: ['./about-salon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutSalonComponent implements OnInit {
  @Input() salonDetails: ISalonDetailsApi;
  salonRoute: Array<string>;

  ngOnInit(): void {
    this.salonRoute = getSalonRoute(this.salonDetails);
  }

}
